import type { FunctionComponent } from 'react';
import styled, { keyframes } from 'styled-components';
import type { PositionAndSizeProps } from '../../utils/styledcomponents';
import { PositionAndSizeFromProps } from '../../utils/styledcomponents';
import type { Points } from '../../data/Score';

export interface Props {
	className?: string;
	points?: Points;
	/**
	 * Animation delay in seconds
	 */
	delay?: number;
}

const ANIMATION = keyframes`
	from {
		opacity: 1;
	}
	80% {
		opacity: 1;
	}
	to {
		opacity: 0;
		left: calc(100vw - (21vmin + 8.4vw + 1em));
		top: 1vmin;
	}
`;

const Text = styled.span<{ delay?: number }>`
	animation-delay: ${(props) => props.delay ?? 0}s;
	animation-duration: 2s;
	animation-name: ${ANIMATION};
	animation-timing-function: ease-out;
	color: ${(props) => props.theme.colors.yellow};
	font: ${(props) => props.theme.font.default};
	font-size: 7vh;
	font-weight: bold;
	opacity: 0;
	pointer-events: none;
`;

const PointsChangeOverlay: FunctionComponent<Props> = (props: Props) => {
	const { className, points = 0, delay } = props;

	if (points !== 0) {
		return (
			<Text className={className} delay={delay}>
				{points >= 0 ? '+' + points : points}
			</Text>
		);
	} else {
		return null;
	}
};

export default styled(PointsChangeOverlay)<PositionAndSizeProps>(
	PositionAndSizeFromProps
);
